import { computed } from 'vue';
import { showSizeDropdown } from '@common-vue/media-card-large/src/modules/size';
import useMembersOfProduct from '@composables/useMembersOfProduct';

export function useSizeDropdown() {
  const { memberProducts } = useMembersOfProduct();

  const showDropdown = computed(() => memberProducts.value.some((member) => {
    const sizes = Object.values(member?.traits?.sizes?.sizeMap || {});
    return showSizeDropdown(sizes);
  }));

  return { showDropdown };
}

export default useSizeDropdown;
